import * as React from 'react';
import { useAppSelector } from 'store/hooks';
import SecclInitialScreen from './SecclInitialScreen';
import InvestIntroView from './InvestIntroView';
import { selectShowInvestIntroFlag } from '../reducers/selectors';
const InvestInitialScreen = () => {
    const showInvestIntro = useAppSelector(selectShowInvestIntroFlag);
    if (showInvestIntro) {
        return <InvestIntroView />;
    }
    return <SecclInitialScreen />;
};
export default InvestInitialScreen;
